import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-600">精选热门黑料内容专题，一站式浏览最新资源</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <article key={item.id} className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:ring-2 hover:ring-primary-200 cursor-pointer">
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-[11px] font-semibold text-background-50 bg-primary-500/90 rounded-md">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-3">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}